<template>
  <v-container>
    <v-row  class="mt-16">
      <v-col cols="12" sm="12" lg="6" offset-lg="3">
        <div class="">
          <router-link :to="{ name: 'startups' }" class="text-decoration-none">
            <h1 class="text-center font-weight-bold">
              Building <br>
              <u>Startups and Enterprise products</u> <br>
              that define our present and future.
            </h1>
            <h4  class="text-center font-weight-bold text-uppercase">
              🌟 For the past 15 years 🚀
            </h4>
          </router-link>
        </div>
      </v-col>
    </v-row>
    <v-row  class="mt-16">
      <v-col cols="12" sm="12" lg="10" offset-lg="1">
        <router-link :to="{ name: 'startups' }" class="text-decoration-none">
          <v-img src="/img/essay/andromeda-technology-overview.png" contain />
        </router-link>
      </v-col>
    </v-row>
    <v-row  class="mt-8">
      <v-col cols="12" sm="12" lg="6" offset-lg="3">
        <section id="Essays">
          <v-card class="mt-16">
            <v-img
              class="white--text align-end"
              height="300"
              cover
              src="/img/essay/andromeda-wallpaper-1.png"
            >
            </v-img>
            <v-alert color="rgba(0,0,0,0)">
              <p>
                Andromeda.Technology partners with clients across Europe and globally, including: EU regions, London, Amsterdam, Berlin, Germany, France, and the UK, United States and international clients.
              </p>
              <br>
              <ol>
                <li>
                  Individual specialists embedded into existing teams
                </li>
                <li>
                  Full-stack teams dedicated as strategic technology partners
                </li>
                <li>
                  End-to-end project development from initial concept to production
                </li>
              </ol>
              <br>
              <p>
                Our preferred engagement is building projects from the ground up, ensuring architecture, technology, and team alignment from day one. Contact us if you have interesting challenges — for complete project leadership, development and consultancy.</p>
            </v-alert>
            <v-card-actions>
              <v-btn block href="https://medium.com/andromeda-technology/andromeda-technology-full-spectrum-software-leadership-for-startups-and-enterprise-projects-dcc339cdb69e">
                <h4>
                  Read the Medium essay
                </h4>
              </v-btn>
            </v-card-actions>
          </v-card>
          <div class="text-center pt-16">
            <v-card
              class="mx-auto"
              max-width="100%"
            >
              <v-img
                class="white--text align-end"
                height="300"
                cover
                src="/img/essay/self-aware-software-artisan.jpeg"
              >
              </v-img>
              <v-alert color="rgba(0,0,0,0)">
                <v-card-title>
                  <h3>
                  Self-Aware Software Artisan
                  </h3>
                </v-card-title>
                <v-card-text class="text-center">
                  <p>
                  Powering individual's continual evolution and meaningful contribution to humanity through Software Development.
                  </p>
                </v-card-text>
              </v-alert>
              <v-card-actions>
                <v-btn block href="https://medium.com/andromeda-technology/self-aware-software-artisan-the-manifesto-e9314290bced">
                  <h4>
                    Read the Medium essay
                  </h4>
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </section>
      </v-col>
    </v-row>
    <section id="Contact">
      <v-row class="mt-16">
        <v-col cols="12" sm="12" offset-lg="3" lg="6">
          <div class="text-center">
            <v-btn href="mailto:hi@andromeda.technology" block color="purple" class="mb-2">
              <v-icon class="pr-4">mdi-mail</v-icon>
              <h3>Contact us</h3>
            </v-btn>
            <v-btn v-if="false" x-large href="http://eepurl.com/hFA-65" block color="purple" class="py-8 mb-2">
              <v-icon large class="mr-4">notifications</v-icon>
              <h2>Subscribe</h2>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </section>
    <section id="TechnologyStack">
      <v-row class="mb-16">
        <v-col cols="12" sm="12" offset-lg="3" lg="6">
            <div class="text-center pb-16">
              <SkillLogo name="TypeScript" src="/img/technology/typescript.png" />
              <SkillLogo name="Solidity" src="/img/technology/solidity.png" />
              <SkillLogo name="NestJS" src="/img/technology/nestjs.png" />
              <SkillLogo name="Koa.js" src="/img/technology/koajs.png" />
              <SkillLogo name="Kafka" src="/img/technology/kafka.png" />
              <SkillLogo name="MongoDB" src="/img/technology/mongo.png" />
              <SkillLogo name="Elasticsearch" src="/img/technology/elasticsearch.png" />
              <SkillLogo name="GraphQL" src="/img/technology/graphql.png" />
              <SkillLogo name="Vue.JS" src="/img/technology/vuejs.png" />
            </div>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import SkillLogo from './SkillLogo.vue'

interface Item {
  name: string
}

export default defineComponent({
  name: "HelloWorld",
  components: {
    SkillLogo,
  },
  props: {
    item: {
      type: Object as PropType<Item>,
      required: true
    },
  },
})
</script>
<style lang="scss">
a {
  color: inherit !important;
}
body {
  background-color: #121212 !important;
}
.v-responsive__content.narrow {
  width: 96px !important;
}
.hover-bg-no.v-btn .v-ripple__container {
  opacity: 0 !important;
}
.hover-bg-no.v-btn::before {
  background-color: transparent !important;
}
</style>